import React from 'react';
import axios from 'axios';
import { findDOMNode } from 'react-dom';
import { withCookies } from 'react-cookie';
import app from '../../index';
import CampaignCreatorForm from './Form';
import RegisterForm from '../register/Form';
import LoginForm from '../login/Form';
import { TransitionGroupMode, TransitionItem } from '../components/transitions/Slide';
import * as i18n from '../../utils/i18n';

class CampaignCreator extends React.Component {
  state = {
    showForm: 'createCampaign',
    form: {},
    wentBack: false,
    formHeight: 'auto',
    errors: {}
  };

  cmp = {};

  showCreateCampaignForm = () => {
    this.setState({
      showForm: 'createCampaign',
      wentBack: true
    });
  };

  showRegisterForm = () => {
    this.setState({
      showForm: 'register',
      wentBack: true
    });
  };

  showLoginForm = () => {
    this.setState({
      showForm: 'login',
      wentBack: false
    });
  };

  submitCampaign = (e, formData) => {
    const { cookies, initProps } = this.props;

    if (window.DRJM.user.hasOwnProperty('id')) {
      const form = this.submitForm;
      grecaptcha.ready(function() {

        grecaptcha.execute(initProps.recaptcha, {action: 'submit'}).then(function(token) {
          form(formData).then(() => {
            const currentLanguage = cookies.get(window.DRJM.config.cookieLangName) || i18n.defaultLocale;
            formData.action = 'create-campaign';
            formData.recaptcha = token
            document.getElementById('loading').style.display = "block";
            axios.post('/p2p/nova/', formData).then((response) => {
              window.location.href = response.data.campaign.public_url;
            }).catch((error) => {
              document.getElementById('loading').style.display = "none";
              const errors = error.response.data.errors

              this.setState({ errors });
            });
          });
        });

      });
    } else {
      this.setState({
        showForm: 'register',
        wentBack: false,
        form: {
          createCampaign: formData,
          register: {},
          login: {}
        }
      });
    }
  };

  submitLogin = (e, loginFormData) => {
    this.setState({
      form: {
        ...this.state.form,
        login: loginFormData
      }
    }, () => {
      const { cookies, initProps } = this.props;
      const formData = {
        ...this.state.form.createCampaign,
        ...this.state.form.login
      };

      const form = this.submitForm;
      grecaptcha.ready(function() {

        grecaptcha.execute(initProps.recaptcha, {action: 'submit'}).then(function(token) {
          form(formData).then(() => {
            const currentLanguage = cookies.get(window.DRJM.config.cookieLangName) || i18n.defaultLocale;

            formData.language = currentLanguage;
            formData.action = 'create-campaign-with-login';
            formData.recaptcha = token
            document.getElementById('loading').style.display = "block";
            axios.post('/p2p/nova/', formData).then((response) => {
              window.location.href = response.data.campaign.public_url;
            }).catch((error) => {
              document.getElementById('loading').style.display = "none";
              app.features.notification('.js-notification', {
                text: error.response.data.errors,
                status: 'error'
              });
            });
          });
        });

      });
    });
  };

  submitRegister = (e, registerFormData) => {
    this.setState({
      form: {
        ...this.state.form,
        register: registerFormData
      }
    }, () => {
      const { cookies, initProps } = this.props;
      const formData = {
        ...this.state.form.createCampaign,
        ...this.state.form.register
      };

      const form = this.submitForm;
      grecaptcha.ready(function() {

        grecaptcha.execute(initProps.recaptcha, {action: 'submit'}).then(function(token) {
          const currentLanguage = cookies.get(window.DRJM.config.cookieLangName) || i18n.defaultLocale;
          formData.language = currentLanguage;
          formData.action = 'create-campaign-with-registration';
          formData.recaptcha = token
          document.getElementById('loading').style.display = "block";
          form(formData).then((response) => {
            window.location.href = response.data.campaign.public_url;
          }).catch((error) => {
            document.getElementById('loading').style.display = "none";
            app.features.notification('.js-notification', {
              text: error.response.data.errors,
              status: 'error'
            });
          });
        });

      });

    });
  };

  submitForm = (formData) => axios.post('/p2p/nova/', formData);

  updateHeight = () => {
    // eslint-disable-next-line react/no-find-dom-node
    const el = findDOMNode(this.cmp[this.state.showForm]);

    if (!el) return;

    const newHeight = el.querySelector('.a-slide__height').clientHeight;

    if (this.state.formHeight !== newHeight) {
      this.setState({
        formHeight: newHeight
      });
    }
  };

  componentDidMount() {
    this.updateHeight();
    window.addEventListener('resize', this.updateHeight);
  }

  componentDidUpdate() {
    this.updateHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight);
  }

  showForgotPassword = (e) => {
    e.preventDefault();
    this.setState({ showForm: 'reset', wentBack: false });
  };

  render() {
    const { showForm, form, wentBack, formHeight: height, errors } = this.state;
    const { initProps: { targetAmount, recaptcha } = { targetAmount: 300 } } = this.props;

    let Form;
    switch (showForm) {
      case 'register':
        Form = (
          <TransitionItem key={1} ref={c => { this.cmp.register = c; }}>
            <RegisterForm
              onSubmit={this.submitRegister}
              onCancel={this.showCreateCampaignForm}
              parentForceRerender={this.updateHeight}
              showLoginForm={this.showLoginForm}
              serverErrors={errors}
              targetAmount={targetAmount}
              recaptcha={recaptcha}
            />
          </TransitionItem>
        );
        break;
      case 'login':
        Form = (
          <TransitionItem key={2} ref={c => { this.cmp.login = c; }}>
            <LoginForm
              onSubmit={this.submitLogin}
              onCancel={this.showRegisterForm}
              onForgot={this.showForgotPassword}
              parentForceRerender={this.updateHeight}
              langSwitcher
              displaySocialLogin={true}
              targetAmount={targetAmount}
              recaptcha={recaptcha}
            />
          </TransitionItem>
        );
        break;
      default:
        Form = (
          <TransitionItem key={3} ref={c => { this.cmp.createCampaign = c; }}>
            <CampaignCreatorForm
              onSubmit={this.submitCampaign}
              form={form.createCampaign}
              parentForceRerender={this.updateHeight}
              serverErrors={errors}
              targetAmount={targetAmount}
              recaptcha={recaptcha}
            />
          </TransitionItem>
        );
    }

    return (
      <TransitionGroupMode height={height + 40 /* lol */} mode="quarter" reversed={wentBack}>
        {Form}
      </TransitionGroupMode>
    );
  }
}

export default withCookies(CampaignCreator);



// WEBPACK FOOTER //
// ./app/Assets/js/features/campaignCreator/index.js